import { LinkedItemType, Timestamp } from '@griply/types';
import { startOfMonth } from 'date-fns';

// The all-tasks calendar sync's lower bound is fixed at creation (start of the reference month) and
// preserved across edits via `existing`; goal/life-area syncs never carry one. `referenceDate` is
// "now" at creation, passed in so the derivation stays pure/testable.
export const resolveSyncTasksFrom = (
  linkedItemType: LinkedItemType,
  existing: Timestamp | null | undefined,
  referenceDate: Timestamp,
): Timestamp | undefined =>
  linkedItemType === LinkedItemType.AllTasks
    ? existing ?? startOfMonth(referenceDate)
    : undefined;
